import { BillingGridDatasource } from '@/modules/billing-module/components/grid/config/datasources/billing-grid.datasource'
import { BillingCaseResponse } from '@/api/services/billing/case-grid/billing-case.dto'
import {
    BillingCaseCategory,
    billingCaseService
} from '@/api/services/billing/case-grid/billing-case.service'
import { CommonFilterModel, CommonParams, ExportCommonParams } from '@/api/resources/common/shared/models/common.models'
import { AgColumnDefinition, IResponseAgGrid } from '@/shared/models/ag-grid.model'
import { billingGridCasesMasterColumnDefs } from '@/modules/billing-module/components/grid/config/column-defs/billing-grid-cases-master.column-defs'
import {
    BillingSearcherMode,
    BillingSearcherParams,
    BillingSearcherCaseMode
} from '@/modules/billing-module/components/searcher/billing-searcher.model'
import { StrictNullable } from '@/shared/types/app.types'
import { PAGINATOR_BIG_PAGE_SIZE } from '@/shared/services/services-constants'
import { GridUtils } from '@/shared/util/grid-utils'
import { ReportGridRequest } from '@/api/services/common.dto'
import { AxiosResponse } from 'axios'

export class BillingGridCasesDatasource extends BillingGridDatasource<BillingCaseResponse> {
    private readonly _category: BillingCaseCategory

    constructor(laboratoryId: number, category: BillingCaseCategory) {
        super(laboratoryId)
        this._category = category
    }

    public getColumnDefs(): AgColumnDefinition[] {
        return billingGridCasesMasterColumnDefs()
    }
    protected fetchData(filterModel: CommonFilterModel, params: CommonParams): Promise<IResponseAgGrid<BillingCaseResponse>> {
        return billingCaseService.paginator(filterModel, params, this.laboratoryId, this._category)
    }

    public exporter(request: ReportGridRequest, params: ExportCommonParams): Promise<AxiosResponse<Blob>> {
        return billingCaseService.export(this.laboratoryId, request, params, this._category)
    }

    public getSearcherModes(): BillingSearcherMode[] {
        return [
            BillingSearcherMode.PATIENT,
            BillingSearcherMode.CASE
        ]
    }
    public searcher(searcherParams: BillingSearcherParams): Promise<StrictNullable<IResponseAgGrid<BillingCaseResponse>>> {
        const { mode, caseScope, patientsIds, identifierSearch } = searcherParams

        const params: CommonParams = {
            size: PAGINATOR_BIG_PAGE_SIZE
        }
        const filterModel: CommonFilterModel = {}
        if (mode === BillingSearcherMode.PATIENT && patientsIds) {
            filterModel['patient.id'] = GridUtils.getSetFilterModel(patientsIds.map(patientId => `${patientId}`))
        } else if (mode === BillingSearcherMode.CASE) {
            let caseFieldName: string | undefined
            if (caseScope === BillingSearcherCaseMode.IDENTIFIER) {
                caseFieldName = 'casCasenumber'
            } else if (caseScope === BillingSearcherCaseMode.INSURANCE_DOCUMENT) {
                caseFieldName = 'referralNumber'
            } else if (caseScope === BillingSearcherCaseMode.INSURANCE_POLICY) {
                caseFieldName = 'insuranceNumber'
            }
            if (caseFieldName) {
                filterModel[caseFieldName] = GridUtils.getTextFilterModel('contains', identifierSearch)
            }
        }
        return this.fetchData(filterModel, params)
    }
}
